import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Divider from "@material-ui/core/Divider";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import Avatar from "@material-ui/core/Avatar";
import Typography from "@material-ui/core/Typography";
import moment from "moment";
import { Box, Paper, Tab, Tabs, Tooltip } from "@material-ui/core";
import Select from "react-select";
import axios from "axios";
import { GET_NEW_MESSAGES } from "../../../../common/constants/ApplicationUrl";
import api from "../../../../common/dependencies/utils/Api";
import clsx from "clsx";
import "./style.scss";

const useStyles = makeStyles((theme) => ({
  overflow: {
    height: "calc(100% - 195px)",
    width: "350px",
    overflowY: "scroll",
    overflowX: "hidden",
    top: "130px",
    left: "0",
    position: "absolute",
    borderRadius: 0,
    [theme.breakpoints.down("md")]: {
      width: "calc(100vw - 100px)",
      left: "80px",
    },
  },
  overFlow2: {
    height: "calc(100% - 94px)",
    width: "350px",
    // overflowX: "hidden",
    top: "150px",
    left: "40px",
    position: "absolute",
    borderRadius: 0,
    [theme.breakpoints.down("md")]: {
      height: "500px",
      top: "300px",
      left: "100px",
      transform: "translateX(-50%)",
    },
  },
  tooltip: {
    backgroundColor: "rgba(118,95,170,1)",
    padding: "10px",
    maxWidth: "none",
  },
  tooltipArrow: {
    backgroundColor: "rgba(118,95,170,1)",
  },
  root: {
    width: "350px",
    backgroundColor: theme.palette.background.paper,
    position: "static",
    height: "100%",
    [theme.breakpoints.down("md")]: {
      width: "calc(100vw - 100px)",
    },
  },
  inline: {
    display: "inline",
  },
  objectFit: {
    objectFit: "contain",
  },
  select: {
    fontSize: "16px",
    width: "100%",
    whiteSpace: "nowrap",
    textAlign: "left",
    fontWeight: "normal",
    // position: 'absolute !important',
    bottom: "10px",
    left: "50%",
    transform: "translateX(-50%)",
  },
  unreadBox: {
    height: "30px",
    width: "30px",
    borderRadius: "50%",
    backgroundColor: "#b499c7",
    color: "white",
    fontSize: "12px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "absolute",
    right: "25px",
    top: "50%",
    transform: "translateY(-50%)",
  },
  firstItem: {
    width: "100%",
    backgroundColor: "#6f59a6",
    color: "white",
    fontFamily: "Montserrat",
    fontWeight: "bold",
    position: "absolute",
    top: 0,
    left: 0,
    [theme.breakpoints.down("md")]: {
      width: "calc(100vw - 100px)",
      left: "80px",
    },
  },
  firstItemSelect: {
    width: "100%",
    backgroundColor: "#6f59a6",
    color: "white",
    fontFamily: "Montserrat",
    // marginTop:"15px",
    fontWeight: "bold",
    position: "absolute",
    top: 70,
    left: 0,
    zIndex: 100,
    [theme.breakpoints.down("md")]: {
      left: "80px",
      width: "calc(100vw - 100px)",
    },
  },
  tab: {
    minWidth: "none",
    fontSize: "16px",
    padding: 0,
  },
}));

export default function AlignItemsList(props) {
  const classes = useStyles();
  const value = JSON.parse(localStorage.getItem("SavedLoggedInData"));

  const removeFirstItem = (arr, label) => {
    let newArr = arr?.filter((item, index) => true);
    newArr?.unshift({ value: "", label: label });
    return newArr;
  };
  const [newMessages, setNewMessages] = useState();
  const [curTab, setCurTab] = useState(0);

  useEffect(() => {
    // axios({
    //   url: GET_NEW_MESSAGES,
    //   method: "post",
    //   data: {
    //     id: value.id,
    //   },
    // })
    //   .then((res) => {
    //     setNewMessages(res.data?.data?.unread);
    //   })
    //   .catch((err) => {
        
    //   });
    api
      .POST(
      GET_NEW_MESSAGES, 
      {
        id: value.id
      }
    ).then(res => {
      setNewMessages(res.data?.data?.unread)
    }).catch(err => {
      
    })
  }, []);

  return (
    <div className={clsx("newoverflow2", classes.overFlow2)}>
    
      <ListItem alignItems="center" className={classes.firstItem}>
        <ListItemAvatar>
          <Avatar
            classes={{
              img: classes.objectFit,
            }}
            src={value?.image}
          />
        </ListItemAvatar>
        <ListItemText
          primary={
            <>
              <Tooltip
                classes={{
                  tooltip: classes.tooltip,
                  tooltipArrow: classes.tooltipArrow,
                }}
                PopperProps={{
                  disablePortal: true,
                }}
                arrow
                placement="top"
                title={
                  <Typography
                    style={{
                      fontFamily: "Montserrat",
                      fontSize: "14px",
                      color: "#fff",
                      fontWeight: "bold",
                      padding: 0,
                      margin: 0,
                    }}
                  >
                    {value?.name}
                  </Typography>
                }
              >
                <div>
                  <Typography
                    noWrap
                    style={{
                      fontFamily: "Montserrat",
                      fontWeight: "bold",
                      color: "white",
                    }}
                  >
                    {value?.name}
                  </Typography>
                </div>
              </Tooltip>
            </>
          }
          secondary={
            <div
              // style={{ display: "flex" }}
              className="newlistitemagainsecondarydiv"
            >
              <Typography
                style={{
                  fontFamily: "Montserrat",
                  color: "white",
                  fontSize: "12px",
                  flex: 1,
                }}
              >
                TOTAL ACTIVE: {props.data?.length}
              </Typography>
              <Typography
                style={{
                  fontFamily: "Montserrat",
                  color: "white",
                  fontSize: "12px",
                }}
              >
                UNREAD : {newMessages}
              </Typography>
            </div>
          }
          className="newlistitemagaintext"
        />
      </ListItem>
      <ListItem
        alignItems="center"
        className={[classes.firstItemSelect, "firstIItem"]}
      >
        <Select
          className={classes.select}
          placeholder="Search"
          options={removeFirstItem(
            props.data?.map((item) => ({
              value: item.id,
              label:
                item.bpartyId === value?.id
                  ? item?.apartyName
                  : item?.bpartyName,
            })),
            "Search"
          )}
          onChange={(selected) => {
            props.setNewChatMode(false);
            const requiredObj = props.data?.find(
              (item) => item.id === selected.value
            );
            const recieverId =
              requiredObj.bpartyId === value?.id
                ? requiredObj.apartyId
                : requiredObj.bpartyId;
            props.onConversationClick(recieverId, requiredObj);
          }}
          styles={{
            menu: (styles) => {
              return {
                ...styles,
                width: "auto",
                zIndex: 1000,
              };
            },
            option: (styles, { data, isDisabled, isFocused, isSelected }) => {
              return {
                ...styles,
                backgroundColor: isSelected
                  ? "#b499c7"
                  : isFocused
                  ? "#e4d7ee"
                  : "white",
                color: isSelected ? "white" : "black",
                cursor: isDisabled ? "not-allowed" : "default",
              };
            },
          }}
        />
      </ListItem>
      <Paper className={classes.overflow}>
        <div className={classes.tabContainer}>
          <Tabs
            // value={0}
            // onChange={() => {}}
            value={curTab}
            onChange={(event, number) => {
              setCurTab(number);
            }}
            indicatorColor="primary"
            textColor="primary"
            variant="fullWidth"
            aria-label="full width tabs example"
          >
            <Tab
              // index={0}
              label="INDIVIDUAL"
              id={`full-width-tab-0`}
              aria-controls={`full-width-tabpanel-0`}
              className={classes.tab}
              onClick={() => {
                props.setClickedTab(false);
                props.setclickedGroupName(false);
                props.setclickedIndiName(true);
                // props.setindividualclickedName(false);
                // props.setcohortclickedName(false);
              }}
            />
            <Tab
              // index={1}
              // label="GROUP"
              label={
                props.grpdata?.length > 0
                  ? `GROUP (${props.grpdata?.length})`
                  : `GROUP`
              }
              id={`full-width-tab-1`}
              aria-controls={`full-width-tabpanel-1`}
              className={classes.tab}
              onClick={() => {
                props.setClickedTab(true);
                props.setclickedGroupName(true);
                props.setclickedIndiName(false);
                // props.setindividualclickedName(false);
                // props.setcohortclickedName(false);
              }}
            />
          </Tabs>
        </div>

        {/* <List className={classes.root}>
          {props.data?.map((datum) => (
            <>
              <ListItem
                button
                onClick={() => {
                  props.setNewChatMode(false);
                  let value = JSON.parse(
                    localStorage.getItem("SavedLoggedInData")
                  );
                  const recieverId =
                    datum.bpartyId === value?.id
                      ? datum.apartyId
                      : datum.bpartyId;
                  props.onConversationClick(recieverId, datum);
                }}
                style={{
                  backgroundColor:
                    props.activeChat?.apartyId === datum.apartyId &&
                    props.activeChat?.bpartyId === datum.bpartyId
                      ? "rgba(0,0,0,0.1)"
                      : "",
                }}
                alignItems="flex-start"
              >
                <ListItemAvatar>
                  <Avatar
                    classes={{
                      img: classes.objectFit,
                    }}
                    alt={datum?.bpartyName}
                    src={
                      datum.bpartyId === value?.id
                        ? datum.apartyImage
                        : datum.bpartyImage
                    }
                  />
                </ListItemAvatar>
                <ListItemText
                  primary={
                    datum.bpartyId === value?.id
                      ? datum.apartyName
                      : datum.bpartyName
                  }
                  secondary={
                    <React.Fragment>
                      <Typography
                        component="span"
                        variant="body2"
                        className={classes.inline}
                        color="textPrimary"
                      >
                        {moment(datum?.lastUpdated).format(
                          "DD-MM-YYYY hh:mm a"
                        )}
                      </Typography>
                    </React.Fragment>
                  }
                />
                {parseInt(datum?.unread) > 0 && (
                  <Box className={classes.unreadBox}>{datum?.unread}</Box>
                )}
              </ListItem>
              <Divider variant="inset" component="li" />
            </>
          ))}
        </List> */}
        {props.clickedTab === false ? (
          <List className={classes.root}>
            {props.data?.map((datum) => (
              <>
                <ListItem
                  button
                  onClick={() => {
                    props.setClickedTab(false);
                    // props.setcohortclickedName(false);
                    // props.setindividualclickedName(true);
                    // props.setclickedGroupName(false);
                    props.setclickedGroupName(true);
                    props.setclickedIndiName(false);
                    props.setNewChatMode(false);
                    let value = JSON.parse(
                      localStorage.getItem("SavedLoggedInData")
                    );
                    const recieverId =
                      datum.bpartyId === value?.id
                        ? datum.apartyId
                        : datum.bpartyId;
                    props.onConversationClick(recieverId, datum);
                  }}
                  style={{
                    backgroundColor:
                      props.activeChat?.apartyId === datum.apartyId &&
                      props.activeChat?.bpartyId === datum.bpartyId
                        ? "rgba(0,0,0,0.1)"
                        : "",
                  }}
                  alignItems="flex-start"
                >
                  <ListItemAvatar>
                    <Avatar
                      classes={{
                        img: classes.objectFit,
                      }}
                      alt={datum?.bpartyName}
                      src={
                        datum.bpartyId === value?.id
                          ? datum.apartyImage
                          : datum.bpartyImage
                      }
                    />
                  </ListItemAvatar>
                  <ListItemText
                    primary={
                      <Typography className={classes.smallText}>
                        {datum.bpartyId === value?.id
                          ? datum.apartyName
                          : datum.bpartyName}
                      </Typography>
                    }
                    secondary={
                      <React.Fragment>
                        <Typography
                          component="span"
                          variant="body2"
                          className={classes.inline}
                          color="textPrimary"
                        >
                          {moment(datum?.lastUpdated).format(
                            "DD-MM-YYYY hh:mm a"
                          )}
                        </Typography>
                      </React.Fragment>
                    }
                  />
                  {parseInt(datum?.unread) > 0 && (
                    <Box className={classes.unreadBox}>{datum?.unread}</Box>
                  )}
                </ListItem>
                <Divider variant="inset" component="li" />
              </>
            ))}
          </List>
        ) : (
          <List className={classes.root}>
            {props.data?.map((datum) => (
              <>
                <ListItem
                  button
                  onClick={() => {
                    props.setMessageuserrole(datum?.groupAdminRole);

                    props.setClickedTab(true);
                    // props.setcohortclickedName(false);
                    // props.setindividualclickedName(false);
                    // props.setclickedGroupName(true);
                    props.setclickedGroupName(false);
                    props.setclickedIndiName(true);
                    props.setNewChatMode(false);
                    let value = JSON.parse(
                      localStorage.getItem("SavedLoggedInData")
                    );
                    const recieverId =
                      datum.cohortId === value?.id ? datum.cohortId : "";
                    props.onConversationClick(recieverId, datum);
                    props.setdatumidgroup(datum?.id);
                    props.setdatumidconvo("");
                  }}
                  style={{
                    backgroundColor:
                      props.datumidgroup === datum?.id ? "rgba(0,0,0,0.1)" : "",
                  }}
                  alignItems="flex-start"
                >
                  <ListItemAvatar>
                    <Avatar
                      classes={{
                        img: classes.objectFit,
                      }}
                      alt={datum?.bpartyName}
                      src={
                        datum.bpartyId === value?.id
                          ? datum.apartyImage
                          : datum.bpartyImage
                      }
                    />
                  </ListItemAvatar>
                  <ListItemText
                    primary={
                      <Typography className={classes.smallText}>
                        {/* {datum?.adminName} */}
                        {datum?.groupSubject}
                      </Typography>
                    }
                    secondary={
                      <React.Fragment>
                        <Typography
                          component="span"
                          variant="body2"
                          className={classes.inline}
                          color="textPrimary"
                        >
                          {/* {moment(datum?.lastUpdated).format( */}
                          {moment(datum?.lastMessageDate).format(
                            "DD-MM-YYYY hh:mm a"
                          )}
                        </Typography>
                      </React.Fragment>
                    }
                  />
                  {parseInt(datum?.unread) > 0 && (
                    <Box className={classes.unreadBox}>{datum?.unread}</Box>
                  )}
                </ListItem>
                <Divider variant="inset" component="li" />
              </>
            ))}
          </List>
        )}
      </Paper>
    </div>
  );
}
